import {makeAutoObservable, observable} from "mobx";
import {generateRandomString} from "../../../utils/generateRandomString";
import {autoAction} from "mobx/dist/api/action";
import {array} from "prop-types";
import moment from "moment";


export const CalendarModalStore = class {
    departureInFocus = null


    error = []

    isHolliday
    //Новые выезды
    newDepartures = []
    confirmedDepartures = []
    //Старые выезды
    oldDepartures = []
    editedDepartures = []

    info = {
        verificationCenter: {
            name: "",
            _id: ""
        },
        medCenter: {
            name: "",
            _id: ""
        },
        organization: {
            name: "",
            _id: ""
        },
    }


    setErrors = (error) => {
        this.error = error
    }

    constructor() {
        makeAutoObservable(this)
    }

    setDepartureInFocus = (id) => {
        this.departureInFocus === id
            ? (this.departureInFocus = "")
            : (this.departureInFocus = id)
    }
    //info


    infoHandler = (type, id, name) => {
        this.info = {...this.info, [type]: {_id: id, name}}
    }

    setInfo = (info) => {
        this.info = {
            verificationCenter: {
                _id: info?.verification_center?.id || "",
                name: info?.verification_center?.name || " ",
            },
            medCenter: {
                _id: info?.med_center?.id,
                name: info?.med_center?.name,
            },
            organization: {
                _id: info?.organization?.id,
                name: info?.organization?.name,
            }
        }
    }

    setHoliday = (holiday, amoId) => {
        if (amoId)
            this.isHolliday = holiday
    }
    //departures

    getAllDepartures = () => {
        return [...this.oldDepartures, ...this.newDepartures]
    }

    setOldDepartures = (departures) => {
        departures.forEach(dep => {
            if (dep.type === 'new') {
                this.newDepartures.push(dep)
            } else {
                this.oldDepartures.push({...dep, type: 'old'})
            }
        })
    }

    createDeparture = () => {
        const departure = this.generateDeparture()
        this.newDepartures.push(departure)
        this.setDepartureInFocus(departure.id)
    }


    generateDeparture = (inFocus = true, address = "", comment = "", isOpen = true, start_date = new Date(), end_date = new Date()) => {
        return (
            {
                id: generateRandomString(10),
                address,
                comment,
                start_date,
                end_date,
                type: 'new'
            }
        )
    }


    saveDeparture = (departure) => {
        if (departure.start_date && departure.end_date) {
            if (departure.type === "new") this.saveNewDeparture(departure)
            if (departure.type === "old") this.saveEditedDeparture(departure)
        }
    }

    saveNewDeparture = (departure) => {
        const prev = this.newDepartures.find((dep) => dep.id === departure.id)
        if (prev) {
            const prevIndex = this.newDepartures.indexOf(prev)
            this.newDepartures[prevIndex] = {...prev, ...departure}

        } else {
            this.newDepartures.push(departure)

        }
    }

    saveEditedDeparture = (departure) => {

        const prev = this.oldDepartures.find((dep) => dep.id === departure.id)
        if (prev) {
            const prevIndex = this.oldDepartures.indexOf(prev)
            this.oldDepartures[prevIndex] = {...prev, ...departure}

        } else {
            this.oldDepartures.push(departure)
        }
    }

    deleteDeparture = (dep, callback) => {

        if (dep) {
            if (this.getAllDepartures().length > 1) {
                this.confirmedDepartures = this.deleteItem(this.confirmedDepartures, dep?.id)
                this.newDepartures = this.deleteItem(this.newDepartures, dep?.id)
                this.editedDepartures = this.deleteItem(this.editedDepartures, dep?.id)
                this.oldDepartures = this.deleteItem(this.oldDepartures, dep?.id)
                callback()
            } else {
                const errors = this.error || []
                const def = errors?.push("Нельзя удалить единственный выезд")
                this.error = errors

            }


        }


    }

    deleteItem = (arr, id) => {
        if (arr) {
            const toDelete = arr.find(item => id === item.id)
            const toDeleteIndex = arr.indexOf(toDelete)
            if (toDeleteIndex >= 0) {
                arr.splice(toDeleteIndex, 1)
                return arr
            }
        }
        return arr
    }
//api

    prepareToAdd = (departure) => {
        return {
            info: this.info,
            isSecured: false,
            isHolliday: this.isHolliday,
            departures: this.newDepartures.map(dep => {
                delete dep.id
                return {...dep}
            }),
        }
    }

    prepareToSaveEdited = () => {
        return {
            info: this.info,
            isHolliday: this.isHolliday,
            isSecured: false,
            departures: [
                ...this.oldDepartures,
                ...this.newDepartures.map(dep => {
                    delete dep.id
                    return {...dep}
                })
            ]
        }
    }

//other
    validate = () => {
        const errors = []
        !this.info?.verificationCenter?._id && errors.push("Выберите удостоверяющий центр")

        this.getAllDepartures().forEach(item => {

            const start = moment(item.start_date)?.unix()
            const end = moment(item.end_date)?.unix()

            const error = "Неправильные даты"

            start > end && errors.push(error)
            moment(item.start_date).format() == "Invalid date" && errors.push(error)
            moment(item.end_date).format() == "Invalid date" && errors.push(error)
        })
        this.setErrors(errors)
    }
    reset = () => {
        this.error = null
        this.departureInFocus = null
        this.confirmedDepartures = []
        this.isHolliday = false
        this.oldDepartures = []
        this.newDepartures = []
        this.editedDepartures = []
        this.info = {
            verificationCenter: {
                name: "",
                _id: ""
            },
            medCenter: {
                name: "",
                _id: ""
            },
            organization: {
                name: "",
                _id: ""
            },
        }
    }
}

export default CalendarModalStore